import { render, staticRenderFns } from "./RatingBinary.vue?vue&type=template&id=6ad144a2"
import script from "./RatingBinary.vue?vue&type=script&lang=js"
export * from "./RatingBinary.vue?vue&type=script&lang=js"
import style0 from "./RatingBinary.vue?vue&type=style&index=0&id=6ad144a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports